/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WorkflowsService {

    /**
     * Get workflow metadata
     * Retrieve workflow metadata and rule sets for specified scopes.
     * @returns any
     * @throws ApiError
     */
    public static workflowsMetaRetrieve({
        scope,
    }: {
        /**
         * Workflow scope identifier(s) to retrieve metadata for. Multiple scopes can be specified by repeating the parameter. Example: ?scope=assignments.opportunity&scope=connections.connectedfacility
         */
        scope: Array<string>,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/workflows/meta/',
            query: {
                'scope': scope,
            },
        });
    }

}
